export const products = [
  {
    id: 'p1',
    name: 'Horizon Pro Standing Desk',
    price: 699,
    category: 'posture',
    specs: ['Dual Motor', '300lb Capacity', 'Memory Keypad'],
    image: 'https://images.unsplash.com/photo-1593640408182-31c70c8268f5?auto=format&fit=crop&q=80&w=800',
    tag: 'Bestseller'
  },
  {
    id: 'p2',
    name: 'SpineAlign Task Chair',
    price: 450,
    category: 'posture',
    specs: ['Dynamic Lumbar', '4D Armrests', 'Mesh Back'],
    image: 'https://images.unsplash.com/photo-1505843490538-5133c6c7d0e1?auto=format&fit=crop&q=80&w=800'
  },
  {
    id: 'p3',
    name: 'Stealth Cable Management Tray',
    price: 45,
    category: 'cables',
    specs: ['Powder-coated Steel', 'No-drill Mount', 'Power Strip Cradle'],
    image: 'https://images.unsplash.com/photo-1591488320449-011701bb6704?auto=format&fit=crop&q=80&w=800'
  },
  {
    id: 'p4',
    name: 'MagNode 3-in-1 Charging Dock',
    price: 120,
    category: 'charging',
    specs: ['15W MagSafe', 'Weighted Base', 'CNC Aluminum'],
    image: 'https://images.unsplash.com/photo-1620189507195-68309c04c4d0?auto=format&fit=crop&q=80&w=800'
  },
  {
    id: 'p5',
    name: 'DeepWork Pomodoro Timer',
    price: 35,
    category: 'focus',
    specs: ['Tactile Dial', 'E-ink Display', 'USB-C Rechargeable'],
    image: 'https://images.unsplash.com/photo-1584006682522-dc17d6c0d9ac?auto=format&fit=crop&q=80&w=800'
  },
  {
    id: 'p6',
    name: 'Acoustic Desk Panel',
    price: 110,
    category: 'focus',
    specs: ['0.8 NRC Rating', 'Recycled PET', 'Clamp Mount'],
    image: 'https://images.unsplash.com/photo-1518455027359-f3f8164ba6bd?auto=format&fit=crop&q=80&w=800'
  }
];

export const bundles = [
  {
    id: 'b1',
    name: 'The Engineer Setup',
    price: 1150,
    originalPrice: 1290,
    items: ['Horizon Pro Desk', 'Stealth Tray', 'Dual Monitor Arm'],
    image: 'https://images.unsplash.com/photo-1527443224154-c4a3942d3acf?auto=format&fit=crop&q=80&w=800'
  },
  {
    id: 'b2',
    name: 'The Deep Work Pod',
    price: 890,
    originalPrice: 980,
    items: ['SpineAlign Chair', 'Acoustic Panel', 'DeepWork Timer'],
    image: 'https://images.unsplash.com/photo-1499951360447-b19be8fe80f5?auto=format&fit=crop&q=80&w=800'
  }
];

export const compareData = [
  { feature: 'Model', item1: 'Horizon Basic', item2: 'Horizon Pro', item3: 'Horizon Max' },
  { feature: 'Motor Type', item1: 'Single', item2: 'Dual', item3: 'Dual Heavy-duty' },
  { feature: 'Lift Capacity', item1: '150 lbs', item2: '300 lbs', item3: '350 lbs' },
  { feature: 'Height Range', item1: '28" - 46"', item2: '24" - 50"', item3: '22" - 51"' },
  { feature: 'Warranty', item1: '3 Years', item2: '7 Years', item3: '10 Years' },
  { feature: 'Price', item1: '$399', item2: '$699', item3: '$899' },
];

export const faqs = [
  {
    q: 'What is the lead time for desk orders?',
    a: 'Standard desks ship within 2-3 business days. Custom configurations require 5-7 business days for CNC milling and finishing.'
  },
  {
    q: 'Are the cable trays compatible with other desks?',
    a: 'Yes. Our stealth trays use a universal clamp system spanning 0.5" to 2.5" desktop thickness.'
  },
  {
    q: 'What is your return policy?',
    a: '30-day risk-free trial on all seating and desking. Items must be returned in original packaging. Return shipping is deducted from the refund.'
  },
  {
    q: 'Do you offer bulk enterprise pricing?',
    a: 'Yes, for orders of 10+ workstations. Contact enterprise@deskharbor.com for a custom quote and layout planning.'
  }
];